// extracted by mini-css-extract-plugin
export var alertIcon = "_tl-0";